__turbopack_context__.v({
  "basic": "ProducerContact-module-scss-module__a2Cm-W__basic",
  "cards-wrapper": "ProducerContact-module-scss-module__a2Cm-W__cards-wrapper",
  "context": "ProducerContact-module-scss-module__a2Cm-W__context",
  "flex": "ProducerContact-module-scss-module__a2Cm-W__flex",
  "header": "ProducerContact-module-scss-module__a2Cm-W__header",
  "offering-content": "ProducerContact-module-scss-module__a2Cm-W__offering-content",
  "pro": "ProducerContact-module-scss-module__a2Cm-W__pro",
  "pro-cards": "ProducerContact-module-scss-module__a2Cm-W__pro-cards",
  "scrollable-pro-cards": "ProducerContact-module-scss-module__a2Cm-W__scrollable-pro-cards",
  "toggle": "ProducerContact-module-scss-module__a2Cm-W__toggle",
});
